$bog_pazzle_upload $mol_list
	image_uri \
	picked? null
	grid_rows? 4
	grid_columns? 4
	numbers? true
	start? null
	Preview $bog_pazzle_board
	Image_control $bog_pazzle_upload_image
		image_uri <= image_uri
		picked? <=> picked?
	Settings $bog_pazzle_settings
		grid_rows? <=> grid_rows?
		grid_columns? <=> grid_columns?
		numbers? <=> numbers?
	rows <= upload_content /
		<= Image $mol_labeler
			title \Картинка
			content /
				<= Image_control
		<= Hint $mol_text
			text \Подойдёт любое фото с телефона — оно ужмётся само.
		<= Settings_title $mol_text
			text \Настройки
		<= Settings
		<= Preview_title $mol_text
			text \Как ляжет сетка
		<= Preview
		<= Start $mol_button_major
			title \Начать игру
			click? <=> start?
